import { ApiQueryKey } from '@/configs/apiQueryKey';
import { Admin } from '@/types/users';
import EntityApi, { BaseEntity } from './EntityApi';

export enum Currency {
	PLN = 'PLN',
	EUR = 'EUR',
}

export enum CompanyTransportType {
	INTERIOR = 'INTERIOR',
	EXTERIOR = 'EXTERIOR',
}

export enum CompanyStatus {
	ACTIVE = 'ACTIVE',
	INACTIVE = 'INACTIVE',
}

export interface Company extends BaseEntity {
	name: string;
	admin?: Admin;
	status: CompanyStatus;
	contactPerson: string;
	country: string;
	vatNumber: string;
	city: string;
	postalCode: string;
	street: string;
	houseNumber: string;
	preferredCurrency: Currency;
	preferredTransportType: CompanyTransportType;
}

class CompanyApi extends EntityApi<Company> {
	constructor() {
		super(ApiQueryKey.companies);
	}
}

export default new CompanyApi();
